// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Nav from "../../resources/navigation/Nav.res.js";
import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as Card from "../../resources/layout-and-structure/Card.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Title from "../../resources/typography/Title.res.js";
import * as React from "react";
import * as Button from "../../resources/actions/Button.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Spinner from "../../resources/feedback-indicators/Spinner.res.js";
import * as Tooltip from "../../resources/overlays/Tooltip.res.js";
import * as Notifier from "../../bundles/Notifier/Notifier.res.js";
import * as OrderEdit from "../../app/Order/OrderEdit.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as HelpCenter from "../../core/HelpCenter.res.js";
import * as InlineText from "../../resources/layout-and-structure/InlineText.res.js";
import * as TextAction from "../../resources/actions/TextAction.res.js";
import * as CartProduct from "../Cart/CartProduct.res.js";
import * as OrderStatus from "./OrderStatus.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as SpinnerModal from "../../resources/feedback-indicators/SpinnerModal.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as OrderEditForm from "./OrderEditForm.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Client from "@apollo/client";
import * as CatalogProduct from "../Catalog/CatalogProduct.res.js";
import * as OrderCartTable from "./OrderCartTable.res.js";
import * as SessionTracker from "../../core/SessionTracker.res.js";
import * as CartOptionsView from "../Cart/CartOptionsView.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as OrderPageActions from "./OrderPageActions.res.js";
import * as OrderCart__Config from "./OrderCart__Config.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as OrderCartVATLookup from "./OrderCartVATLookup.res.js";
import * as OrderCartActionsBar from "./OrderCartActionsBar.res.js";
import * as PageBottomActionsBar from "../../resources/layout-and-structure/PageBottomActionsBar.res.js";
import * as OrderCartSummaryAmounts from "./OrderCartSummaryAmounts.res.js";
import * as OrderProductFormAutoPicker from "./OrderProductFormAutoPicker.res.js";
import * as OrderCartGlobalFeePickerModal from "./OrderCartGlobalFeePickerModal.res.js";
import * as ReasonMLCommunity__ApolloClient from "rescript-apollo-client/src/ReasonMLCommunity__ApolloClient.res.js";
import * as OrderProductFormPickerModalTable from "./OrderProductFormPickerModalTable.res.js";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";
let Raw = {};
let query = Client.gql(["fragment supplier on Supplier   {\n__typename  \nid  \ncompanyName  \n}\n"]);
function parse(value) {
  return {
    __typename: value.__typename,
    id: value.id,
    companyName: value.companyName
  };
}
function serialize(value) {
  let value$1 = value.companyName;
  let value$2 = value.id;
  let value$3 = value.__typename;
  return {
    __typename: value$3,
    id: value$2,
    companyName: value$1
  };
}
function verifyArgsAndParse(_supplier, value) {
  return parse(value);
}
function verifyName(_fragmentName) {}
let SupplierNameFragment = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  verifyArgsAndParse: verifyArgsAndParse,
  verifyName: verifyName
};
let Raw$1 = {};
let query$1 = Client.gql(["query SupplierQuery($id: ID!)  {\nsupplier(id: $id)  {\n__typename  \nid  \nvariants  {\n__typename  \ntotalCount  \n}\n\n}\n\n}\n"]);
function parse$1(value) {
  let value$1 = value.supplier;
  let tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    let value$2 = value$1.variants;
    tmp = {
      __typename: value$1.__typename,
      id: value$1.id,
      variants: {
        __typename: value$2.__typename,
        totalCount: value$2.totalCount
      }
    };
  }
  return {
    supplier: tmp
  };
}
function serialize$1(value) {
  let value$1 = value.supplier;
  let supplier;
  if (value$1 !== undefined) {
    let value$2 = value$1.variants;
    let value$3 = value$2.totalCount;
    let value$4 = value$2.__typename;
    let variants = {
      __typename: value$4,
      totalCount: value$3
    };
    let value$5 = value$1.id;
    let value$6 = value$1.__typename;
    supplier = {
      __typename: value$6,
      id: value$5,
      variants: variants
    };
  } else {
    supplier = null;
  }
  return {
    supplier: supplier
  };
}
function serializeVariables(inp) {
  return {
    id: inp.id
  };
}
function makeVariables(id, param) {
  return {
    id: id
  };
}
let SupplierVariantsCountQuery_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables
};
let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$1,
  Raw: Raw$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables
});
let use = include.use;
let SupplierVariantsCountQuery_refetchQueryDescription = include.refetchQueryDescription;
let SupplierVariantsCountQuery_useLazy = include.useLazy;
let SupplierVariantsCountQuery_useLazyWithVariables = include.useLazyWithVariables;
let SupplierVariantsCountQuery = {
  SupplierVariantsCountQuery_inner: SupplierVariantsCountQuery_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  refetchQueryDescription: SupplierVariantsCountQuery_refetchQueryDescription,
  use: use,
  useLazy: SupplierVariantsCountQuery_useLazy,
  useLazyWithVariables: SupplierVariantsCountQuery_useLazyWithVariables
};
let styles = {
  emptyDataView: {
    "backgroundColor-kWkggS": "backgroundColor-xhb2u9n",
    "borderBottomColor-kL6WhQ": "borderBottomColor-xmf12dl",
    "borderBottomStyle-kfdmCh": "borderBottomStyle-x1q0q8m5",
    "borderBottomWidth-kt9PQ7": "borderBottomWidth-xso031l",
    "alignItems-kGNEyG": "alignItems-x6s0dn4",
    "display-k1xSpc": "display-x78zum5",
    "flexDirection-kXwgrk": "flexDirection-xdt5ytf",
    "paddingBlock-k8WAf4": "paddingBlock-xshveej",
    $$css: "wino-gc:src/modules/Order/OrderCart.res.js:190"
  }
};
let make = React.memo(props => {
  let newrecord = {
    ...{
      className: "backgroundColor-xhb2u9n borderBottomColor-xmf12dl borderBottomStyle-x1q0q8m5 borderBottomWidth-xso031l alignItems-x6s0dn4 display-x78zum5 flexDirection-xdt5ytf paddingBlock-xshveej",
      "data-style-src": "wino-gc:src/modules/Order/OrderCart.res.js:190"
    }
  };
  return JsxRuntime.jsxs("div", (newrecord.children = [JsxRuntime.jsx(Spinner.make, {
    size: 40
  }), JsxRuntime.jsxs(Box.make, {
    children: [JsxRuntime.jsx(Title.make, {
      children: I18n.template(I18n.t("Search for {{supplier}} products in progress..."), {
        supplier: props.supplierName
      }, undefined),
      level: 3
    }), JsxRuntime.jsx(Box.make, {
      spaceTop: "xsmall"
    }), JsxRuntime.jsx(TextStyle.make, {
      children: I18n.t("Analyzing products and their stock"),
      align: "center"
    })],
    spaceY: "normal"
  })], newrecord));
});
let Loading = {
  make: make
};
let make$1 = React.memo(props => {
  let onPressCreateOrder = props.onPressCreateOrder;
  let errorMessage = props.errorMessage;
  let disabled = props.disabled;
  let newrecord = {
    ...{
      className: "backgroundColor-xhb2u9n borderBottomColor-xmf12dl borderBottomStyle-x1q0q8m5 borderBottomWidth-xso031l alignItems-x6s0dn4 display-x78zum5 flexDirection-xdt5ytf paddingBlock-xshveej",
      "data-style-src": "wino-gc:src/modules/Order/OrderCart.res.js:190"
    }
  };
  return JsxRuntime.jsxs("div", (newrecord.children = [JsxRuntime.jsxs(InlineText.make, {
    children: [JsxRuntime.jsx(TextStyle.make, {
      children: I18n.t("To save typing time, opt for the") + " ",
      variation: "normal",
      size: "xsmall"
    }), JsxRuntime.jsx(TextAction.make, {
      text: I18n.t("automatic order"),
      size: "compact",
      highlighted: true,
      onPress: () => HelpCenter.showArticle(HelpCenter.automaticOrdering)
    }), JsxRuntime.jsx(TextStyle.make, {
      children: " :",
      variation: "normal",
      size: "xsmall"
    })]
  }), JsxRuntime.jsx(Tooltip.make, {
    children: JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsx(Button.make, {
        label: I18n.t("Create automatic order"),
        disabled: disabled,
        onPress: () => onPressCreateOrder()
      }),
      spaceTop: "normal",
      spaceBottom: "xsmall"
    }),
    content: JsxRuntime.jsx(Tooltip.Span.make, {
      text: I18n.t("Please select a supplier linked to the order.")
    }),
    disabled: !disabled,
    delay: 0
  }), errorMessage !== undefined ? JsxRuntime.jsx(Box.make, {
    children: JsxRuntime.jsx(TextStyle.make, {
      children: errorMessage,
      variation: "negative",
      size: "xsmall"
    }),
    spaceTop: "normal"
  }) : null], newrecord));
});
let Default = {
  make: make$1
};
let CartPlaceholder = {
  styles: styles,
  Loading: Loading,
  Default: Default
};
function OrderCart(props) {
  let onRequestDispatch = props.onRequestDispatch;
  let onRequestCancelEdition = props.onRequestCancelEdition;
  let edition = props.edition;
  let editable = props.editable;
  let statuses = props.statuses;
  let cart = props.cart;
  let orderId = props.orderId;
  let match = Nav.Context.use();
  let notifier = Notifier.use(undefined, undefined);
  let formState = OrderEditForm.useFormState();
  let match$1 = React.useState(() => "Pristine");
  let setAutoPickingStatus = match$1[1];
  let autoPickingStatus = match$1[0];
  let match$2 = React.useState(() => false);
  let setSupplierProductsModalOpened = match$2[1];
  let match$3 = React.useReducer(OrderCart__Config.reducer, OrderCart__Config.initialState);
  let dispatch = match$3[1];
  let state = match$3[0];
  let apolloClient = ReasonMLCommunity__ApolloClient.React.useApolloClient();
  let captureEvent = SessionTracker.useCaptureEvent();
  let orderShop = Auth.useShops().find(shop => shop.id === formState.values.shopId);
  let standardVAT = Stdlib_Option.flatMap(orderShop, shop => OrderCartVATLookup.getVATRateByCountry(shop.country));
  let supplierId = formState.values.supplierId;
  let supplierName = React.useMemo(() => Stdlib_Option.flatMap(apolloClient.rescript_readFragment({
    query: query,
    Raw: Raw,
    parse: parse,
    serialize: serialize
  }, "Supplier:" + supplierId, undefined, undefined, undefined, undefined), result => {
    if (result.TAG === "Ok") {
      return result._0.companyName;
    }
  }), [supplierId]);
  let match$4 = use(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, supplierId === "", undefined, {
    id: supplierId
  });
  let match$5 = match$4.data;
  let tmp;
  if (match$5 !== undefined) {
    let match$6 = match$5.supplier;
    tmp = match$6 !== undefined ? match$6.variants.totalCount : undefined;
  } else {
    tmp = undefined;
  }
  let supplierVariantsCount = Stdlib_Option.getOr(tmp, 0);
  React.useEffect(() => {
    if (standardVAT !== undefined && standardVAT !== cart.standardTaxRate) {
      onRequestDispatch({
        TAG: "StandardTaxRateUpdated",
        _0: standardVAT
      });
    }
  }, [standardVAT]);
  React.useEffect(() => {
    if (typeof autoPickingStatus !== "object") {
      switch (autoPickingStatus) {
        case "Pristine":
          break;
        case "Loading":
          captureEvent("create_automatic_order");
          break;
        case "Error":
          notifier.reset({
            TAG: "Error",
            _0: I18n.t("Something went wrong during the automatic order taking proccess.")
          }, undefined, undefined);
          break;
      }
    } else {
      let quantity = autoPickingStatus._0;
      if (quantity !== 0) {
        notifier.reset({
          TAG: "Success",
          _0: I18n.template(quantity !== 1 ? I18n.t("{{quantity}} products have been correctly added to the cart.") : I18n.t("1 product has been correctly added to the cart."), {
            quantity: quantity.toString()
          }, undefined)
        }, undefined, undefined);
      } else {
        notifier.reset({
          TAG: "Warning",
          _0: I18n.template(I18n.t("No products matching the set stock thresholds were found for the supplier {{supplier}}."), {
            supplier: Stdlib_Option.getOr(supplierName, "(?)")
          }, undefined)
        }, undefined, undefined);
      }
    }
  }, [autoPickingStatus]);
  let onRequestCartLoading = state => dispatch({
    TAG: "CartLoadingStateRequested",
    _0: state
  });
  let onRequestProductPickerModalOpen = opened => dispatch({
    TAG: "ProductPickerModalCalled",
    _0: opened
  });
  let onRequestGlobalFeeModalOpen = opened => dispatch({
    TAG: "GlobalFeeModalCalled",
    _0: opened
  });
  let onRequestFileImport = React.useCallback(file => {
    let shopId = formState.values.shopId;
    if (shopId !== "") {
      return dispatch({
        TAG: "FileImported",
        _0: file,
        _1: shopId
      });
    } else {
      return notifier.reset({
        TAG: "Error",
        _0: I18n.t("Please select the shop catalog from which the CSV products will be imported.")
      }, undefined, undefined);
    }
  }, [formState.values.shopId]);
  let onPickProducts = React.useCallback(products => onRequestDispatch({
    TAG: "BatchProductAdded",
    _0: products
  }), []);
  let onPickGlobalFee = React.useCallback(globalFee => {
    let amount = globalFee.amount;
    let tmp;
    tmp = globalFee.globalFeeKind === "FeePerUnit" ? {
      TAG: "ProductsFeePerUnitAllocated",
      _0: amount
    } : {
      TAG: "ProductsFeeProratedByPriceAllocated",
      _0: amount
    };
    onRequestDispatch(tmp);
  }, []);
  let onRequestSupplierProducts = React.useCallback(() => {
    let fetcher = after => {
      let supplier = supplierId !== "" ? {
        id: supplierId,
        name: Stdlib_Option.getOr(supplierName, "")
      } : undefined;
      return apolloClient.rescript_query({
        query: OrderProductFormPickerModalTable.Query.query,
        Raw: OrderProductFormPickerModalTable.Query.Raw,
        parse: OrderProductFormPickerModalTable.Query.parse,
        serialize: OrderProductFormPickerModalTable.Query.serialize,
        serializeVariables: OrderProductFormPickerModalTable.Query.serializeVariables
      }, undefined, undefined, "NetworkOnly", undefined, OrderProductFormPickerModalTable.makeVariables("", {
        shopId: formState.values.shopId,
        supplier: supplier
      }, after, undefined));
    };
    setSupplierProductsModalOpened(param => true);
    Future.tapOk(Future.mapOk(Future.mapOk(OrderProductFormPickerModalTable.runScanEdges(fetcher, undefined, undefined, undefined), undefined, result => OrderProductFormPickerModalTable.rowsFromEdgesData(result).map(row => OrderProductFormPickerModalTable.setDefaultOrderedQuantityValue(CartProduct.makeProductInput(row.id, row.formattedName, CatalogProduct.Information.formatDescription(row.productKind, row.information, undefined, undefined, undefined, undefined), undefined, row.stockQuantity, row.packaging, row.tax, row.purchasedPrice, undefined, row.bulkPrecision, row.capacityUnit, undefined)))), undefined, onPickProducts), () => setSupplierProductsModalOpened(param => false));
  }, [supplierId]);
  let columns = React.useMemo(() => {
    let hiddenColumns = OrderEdit.isBeforeReception(statuses) ? "StatusBeforeReception" : "StatusAtAfterReception";
    return OrderCartTable.tableColumns(statuses, hiddenColumns, cart.taxesFree, editable, onRequestDispatch);
  }, [editable]);
  let errors = formState.validation;
  let cartError;
  cartError = errors.TAG === "Ok" ? undefined : Stdlib_Array.filterMap(errors._0, param => {
    if (param[0]._0 === "Cart") {
      return param[1];
    }
  })[0];
  let disabledIds = Stdlib_Array.filterMap(cart.products, product => product._0.identifier);
  let renderBottomActionBarEnd = () => JsxRuntime.jsx(OrderPageActions.make, {
    id: orderId,
    statuses: statuses,
    edition: edition,
    onRequestCancelEdition: onRequestCancelEdition
  });
  let loading = state.loadingState;
  let tmp$1;
  if (loading !== undefined) {
    tmp$1 = JsxRuntime.jsx(Placeholder.make, {
      status: "Loading",
      customText: loading.message
    });
  } else {
    let tmp$2;
    let exit = 0;
    if (typeof autoPickingStatus !== "object" && autoPickingStatus === "Loading" && supplierName !== undefined) {
      tmp$2 = JsxRuntime.jsx(make, {
        supplierName: supplierName
      });
    } else {
      exit = 1;
    }
    if (exit === 1) {
      let match$7 = formState.submission;
      let tmp$3;
      tmp$3 = cartError !== undefined && typeof match$7 === "object" && match$7.TAG === "Failed" ? I18n.t(cartError) : undefined;
      tmp$2 = JsxRuntime.jsx(make$1, {
        disabled: supplierId === "",
        errorMessage: tmp$3,
        onPressCreateOrder: () => setAutoPickingStatus(param => "Loading")
      });
    }
    tmp$1 = JsxRuntime.jsx(OrderCartTable.make, {
      data: {
        TAG: "Done",
        _0: {
          TAG: "Ok",
          _0: cart.products
        }
      },
      columns: columns,
      keyExtractor: OrderCartTable.keyExtractor,
      erroredRowsMap: props.rowErrors,
      hideCard: true,
      maxHeight: 540,
      placeholderEmptyState: tmp$2,
      typesDrop: ["csv", "excel"],
      onSuccessDrop: editable ? file => onRequestFileImport(file) : undefined,
      onErrorDrop: message => notifier.reset({
        TAG: "Error",
        _0: message
      }, undefined, undefined)
    }, supplierId);
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [JsxRuntime.jsx(SpinnerModal.make, {
      title: I18n.t("Add supplier's products"),
      opened: match$2[0]
    }), JsxRuntime.jsx(OrderProductFormPickerModalTable.make, {
      opened: state.productPickerModalOpened,
      shopId: formState.values.shopId !== "" ? formState.values.shopId : undefined,
      supplierId: supplierId,
      supplierName: supplierName,
      disabledIds: disabledIds,
      onCommit: onPickProducts,
      onRequestClose: () => dispatch({
        TAG: "ProductPickerModalCalled",
        _0: false
      })
    }), JsxRuntime.jsx(OrderCartGlobalFeePickerModal.make, {
      opened: state.globalFeeModalOpened,
      onCommit: onPickGlobalFee,
      onRequestClose: () => dispatch({
        TAG: "GlobalFeeModalCalled",
        _0: false
      })
    }), JsxRuntime.jsx(OrderProductFormAutoPicker.make, {
      status: autoPickingStatus,
      orderId: orderId,
      supplierId: supplierId,
      supplierName: supplierName,
      onQueryStatusChange: status => setAutoPickingStatus(param => status),
      onPickProducts: onPickProducts
    }), JsxRuntime.jsxs(Card.make, {
      children: [editable && OrderEdit.isBeforeReception(statuses) ? JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsx(OrderCartActionsBar.make, {
          cartProducts: cart.products,
          shopId: formState.values.shopId,
          supplierId: supplierId,
          supplierVariantsCount: supplierVariantsCount,
          importedCsv: state.file,
          onRequestCartRowsError: props.onRequestCartRowsError,
          onRequestFileImport: onRequestFileImport,
          onRequestCartLoading: onRequestCartLoading,
          onRequestProductPickerModalOpen: onRequestProductPickerModalOpen,
          onRequestGlobalFeeModalOpen: onRequestGlobalFeeModalOpen,
          onRequestSupplierProducts: onRequestSupplierProducts,
          onRequestDispatch: onRequestDispatch
        }),
        spaceX: "large"
      }) : edition ? JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsx(Inline.make, {
          children: JsxRuntime.jsx(Button.make, {
            label: I18n.t("order_cart.actions_bar.allocation_of_costs.text_button"),
            variant: "subtle",
            disabled: cart.products.length <= 0,
            icon: "plus_small",
            onPress: () => dispatch({
              TAG: "GlobalFeeModalCalled",
              _0: true
            })
          })
        }),
        spaceX: "normal"
      }) : null, tmp$1, JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsxs(Inline.make, {
          children: [editable && cart.products.length !== 0 ? JsxRuntime.jsx(CartOptionsView.make, {
            cart: cart,
            statuses: statuses,
            onRequestDispatch: onRequestDispatch
          }) : null, JsxRuntime.jsx(OrderCartSummaryAmounts.make, {
            cart: cart
          })],
          align: editable && cart.products.length !== 0 ? "spaceBetween" : "end",
          alignY: "top"
        }),
        spaceBottom: "normal",
        spaceLeft: "xlarge",
        spaceRight: "xxlarge"
      })],
      variation: "unset"
    }), OrderStatus.has(statuses, "PAID") ? null : JsxRuntime.jsx(PageBottomActionsBar.make, {
      displayThreshold: 160,
      renderEnd: renderBottomActionBarEnd,
      navOpened: match[0].opened
    })]
  });
}
let make$2 = React.memo(OrderCart, (oldProps, newProps) => {
  if (oldProps.cart === newProps.cart && oldProps.rowErrors === newProps.rowErrors && oldProps.statuses === newProps.statuses && oldProps.orderId === newProps.orderId && oldProps.editable === newProps.editable) {
    return oldProps.edition === newProps.edition;
  } else {
    return false;
  }
});
let CartTable;
let CartConfig;
let Utils;
export { CartTable, CartConfig, Utils, SupplierNameFragment, SupplierVariantsCountQuery, CartPlaceholder, make$2 as make };
/* query Not a pure module */